import React from 'react'
import styles from './no-groups.styles'
import injectSheet from 'react-jss'
import noGroups from './no-groups.png'

const NoGroups = ({ classes, onAddGroup }) => (
  <div className={classes.container}>
    <h2>No groups yet</h2>
    <img src={noGroups} alt="There is no groups yet" />
    <p>
      <span className={classes.addGroup} onClick={onAddGroup}>
        Let's create your first group
      </span>
    </p>
  </div>
)

export default injectSheet(styles)(NoGroups)
